import { styled } from 'styled-components';

import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const LoaderIcon = ({
  marginLeft,
  marginRight,
  width = 15,
  containerSize,
  color = 'black70',
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
      <rect x="1.27295" y="11.4545" width="11.4545" height="1.90909" rx="0.954545" fill={getSemanticTextColor(color)} />
      <StyledCircle cx="7" cy="8" r="2" fill={getSemanticTextColor(color)} />
    </svg>
  </DefaultIconWrapper>
);

const StyledCircle = styled.circle`
  animation: f8dsa3mk3d6d8-anim 400ms ease-in-out infinite alternate;
  @keyframes f8dsa3mk3d6d8-anim {
    0% {
      cy: 2;
    }
    100% {
      cy: 8;
    }
  }
`;
